import React, { useState } from 'react'
import Chip from '@mui/material/Chip'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import ResponsiveDialog from '@components/ResponsiveDialog'
import { useReactiveVar } from '@apollo/client'
import { isWholesaleModeVar } from '../../../../apolloClient'
import { useCartShippingDiscountsQuery } from '@graphql/queries/__generated__/cart.generated'
import { CartTypeEnum } from '../../../../generated/gqlTypes'
import { useFlatPageQuery } from '@graphql/queries/__generated__/flatpage.generated'
import { SHIPPING_DISCOUNT_FLATPAGE_URL } from '../../../urls'

const ShippingDiscountChip: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  const isWholesaleMode = useReactiveVar(isWholesaleModeVar)
  const { data: shippingDiscountData } = useCartShippingDiscountsQuery({
    variables: { cartType: isWholesaleMode ? CartTypeEnum.Wholesale : CartTypeEnum.Default },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  })

  const { data: flatpageData } = useFlatPageQuery({
    variables: { url: SHIPPING_DISCOUNT_FLATPAGE_URL },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    skip: !isOpen,
  })

  if (!shippingDiscountData?.cart?.shippingDiscounts.length) return null

  return (
    <>
      <Chip
        icon={<LocalShippingOutlinedIcon />}
        label={<span>Free Shipping Program</span>}
        variant='outlined'
        classes={{ label: 'ml-5 uppercase text-11 font-semibold' }}
        sx={{ color: '#555', padding: '0 5px', borderRadius: '25px' }}
        onClick={() => setIsOpen(true)}
      />
      {flatpageData?.flatpage && (
        <ResponsiveDialog isOpenDialog={isOpen} setIsOpenDialog={setIsOpen} title={flatpageData.flatpage.title}>
          <div
            dangerouslySetInnerHTML={{
              __html: flatpageData.flatpage.content,
            }}
          />
        </ResponsiveDialog>
      )}
    </>
  )
}

export default ShippingDiscountChip
